<template>
  <div>
    <div class="text-xs-center" v-if="loading">
      <v-progress-circular indeterminate color="primary"></v-progress-circular>
    </div>
    <template v-else-if="isError">Something went wrong</template>
    <template v-else>
      <v-data-table :items="orders" class="elevation-1" hide-actions hide-headers>
        <template v-slot:items="props">
          <td>{{ props.item.id }}</td>
          <td class="text-xs-right">{{ props.item.count }}</td>
        </template>
      </v-data-table>
    </template>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import api from '@/api'
import moment from 'moment'
export default {
  props: ['value', 'datefrom', 'dateto'],
  data: function () {
    return {
      loading: true,
      orders: [],
      isError: false
    }
  },
  mounted: function () {
    var vm = this
    vm.getDetail()
  },
  computed: {
    ...mapGetters({
      selectedBot: 'selectedBot'
    })
  },
  methods: {
    getDetail: function () {
      var vm = this
      vm.loading = true
      vm.getAstonRefIdOrderDetail().then(
        function (orders) {
          var sort_order = []
          for (const key in orders) {
            sort_order.push({
              id: key,
              count: orders[key]
            })
          }
          vm.orders = sort_order

          vm.loading = false
        },
        function (error) {
          console.log(error)
          vm.isError = true
          vm.loading = false
        }
      )
    },
    getAstonRefIdOrderDetail: function () {
      var vm = this
      return new Promise((resolve, reject) => {
        var data = {
          pageid: vm.selectedBot.pageid,
          refcode: vm.value,
          datefrom: moment(vm.datefrom).format('YYYY/MM/DD'),
          dateto: moment(vm.dateto).format('YYYY/MM/DD')
        }

        api.getAstonRefIdOrderDetail(data, function (error, response) {
          if (error) {
            reject(error)
          }

          if (response.data) {
            resolve(response.data)
          }
          resolve([])
        })
      })
    }
  },
  watch: {
    value: function () {
      this.getDetail()
    },
    datefrom: function () {
      this.getDetail()
    },
    dateto: function () {
      this.getDetail()
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/template/ecommerce/AstonAdsDetail.vue